{
  "nav": {
    "home": "Home",
    "services": "Dienste",
    "prices": "Preise",
    "projects": "Projekte",
    "about": "Über Khromatik",
    "contact": "Kontakt",
    "email": "Email",
    "linkedin": "LinkedIn"
  },
  "backToProjects": "Zurück zu Projekten",
  "projectOverview": "Projektübersicht",
  "overview": "Übersicht",
  "challenge": "Die Herausforderung",
  "businessNeed": "Das Geschäftsbedürfnis",
  "philosophy": "Die Philosophie",
  "goal": "Das Ziel",
  "solution": "Die Lösung",
  "polestarLandingPage": "Polestar Live Landingpage",
  "footer": {
    "legal": "Impressum"
  },
  "whatsapp": {
    "label": "Per WhatsApp chatten",
    "prefill": "Hallo, möchte ein Video- oder Branding-Projekt besprechen."
  },
  "cookies": {
    "title": "Cookies und Datenschutz",
    "body": "Wir setzen optionale Analyse-Tools (Google Analytics und Microsoft Clarity) ein, um die Nutzung der Website zu verstehen. Sie können nicht notwendige Cookies ablehnen oder akzeptieren. Notwendige Speicherung betrifft Ihre Sprache und diese Auswahl.",
    "learnMore": "Mehr erfahren",
    "accept": "Alle akzeptieren",
    "reject": "Nicht notwendige ablehnen",
    "settings": "Cookie-Einstellungen"
  }
}
